<div class="button-list-container">
  <button
    [disabled]="!scenariosProfiles?.length"
    mat-button
    class="map-top-button"
    [matMenuTriggerFor]="menu"
  >
    <wlm-icon class="vertical-center-icon" icon="profiles"></wlm-icon>
  </button>
  <mat-menu #menu="matMenu" class="profiles-list-menu">
    <div *ngFor="let scenarioProfile of scenariosProfiles">
      <div class="map-top-buton-menu-group">{{ scenarioProfile.name }}</div>
      <button
        mat-button
        class="material-icons-outlined map-top-button-menu-item"
        *ngFor="let profile of scenarioProfile.profiles"
        (click)="selectProfile(profile, scenarioProfile.scenarioId)"
      >
        {{ profile.name }}
      </button>
    </div>
  </mat-menu>
</div>
